import type { UserDto } from '@flightlog/shared';
import { DownloadIcon, PlaneIcon } from '../icons';

interface Props {
  user: UserDto;
  flightsCount: number;
  onLogout: () => void;
}

export function SettingsView({ user, flightsCount, onLogout }: Props) {
  const initial = (user.firstName ?? 'A').slice(0, 1).toUpperCase();

  return (
    <div className="stack">
      <section className="profile">
        <div className="avatar">{initial}</div>
        <div className="profile-body">
          <b>{user.firstName ?? 'Путешественник'}</b>
          <span>{user.username ? `@${user.username}` : `id ${user.tgId}`}</span>
        </div>
        <span className="profile-badge">{flightsCount} рейсов</span>
      </section>

      <section className="section">
        <h2 className="section-title">Данные</h2>
        <div className="menu">
          <a className="menu-row" href="/api/export" download>
            <DownloadIcon />
            <span>Экспорт в JSON</span>
            <em>›</em>
          </a>
          <div className="menu-row menu-row-static">
            <PlaneIcon size={18} />
            <span>База</span>
            <em>PGlite, локально</em>
          </div>
        </div>
      </section>

      <section className="section">
        <h2 className="section-title">Аккаунт</h2>
        <div className="menu">
          <button type="button" className="menu-row" onClick={onLogout}>
            <span>Выйти</span>
            <em>›</em>
          </button>
        </div>
      </section>

      <section className="section">
        <h2 className="section-title">О приложении</h2>
        <div className="about">
          <p>
            Личный журнал полётов — замена App in the Air, который закрылся 19 октября 2024
            года. История загружена из экспорта приложения.
          </p>
          <p className="muted">Версия 0.3.0 · сборка 19.10.2026</p>
        </div>
      </section>
    </div>
  );
}
